document.addEventListener('DOMContentLoaded', function() {
  var strapsVisible = localStorage.getItem('straps_visible');
  var strapPasswordForm = document.querySelector('.strap-password-form');
  var strapPasswordFormSubmit = document.querySelector('#strap-password-form-submit');

  if(strapsVisible !== 'true') {
    if(strapPasswordFormSubmit) {
      strapPasswordFormSubmit.addEventListener('click', function(e) {
        e.preventDefault();
  
        var passwordInput = strapPasswordForm.querySelector('input');
        var passwordValue = passwordInput.value;
  
        if(passwordValue === 'Passw0rd123' || passwordValue === 'passw0rd123') {
          localStorage.setItem('straps_visible', 'true');
          setUserPreference('true').then(function () {
            location.reload();
          });
        } else {
          alert('Incorrect password');
        }
      });
    }
  }

  if(strapsVisible === 'false' || strapsVisible === false) {
    setUserPreference('false');
  }

  async function setUserPreference(value) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          "strap_password_visible": value
        }
      })
    });
  }
});
